import client from './client';

export default {
  create(address, cb) {
    client.request('post', '/addresses', true)
      .send({ address })
      .end(cb);
  },
  update(address, cb) {
    client.request('put', `/addresses/${address.id}`, true)
      .send({ address })
      .end(cb);
  },
  all(cb) {
    client.request('get', '/addresses', true)
      .end(cb);
  },
};



// WEBPACK FOOTER //
// ./src/lib/addresses.js